import { makeStyles } from '@material-ui/core/styles';
import { vh } from 'src/common/helpers/dimension-helper';
import { themeColor } from '../../../mui-theme';

export const styles = makeStyles(theme => ({
  centerMessaging: {
    justifyContent: 'space-between',
    zIndex: 10,
  },
  approveButtonContainer: {
    justifyContent: 'center',
    paddingBottom: '1vh',
  },
  approveButton: {
    backgroundColor: theme.palette.primary.main,
    lineHeight: '1.14',
    letterSpacing: '0.05rem',
    fontWeight: 500,
    fontSize: vh(2.08),
    height: '7.29vh',
    borderRadius: '2px',
    boxShadow: `0 1px 3px 0 ${themeColor.almostwhite}`,
    '& > div': {
      color: themeColor.white,
    },
  },
  leftHandedContent: {
    paddingBottom: '1vh',
    justifyContent: 'flex-start',
    alignContent: 'flex-end',
  },
  paymentInfo: {
    fontSize: vh(3.125),
    fontWeight: 400,
    paddingBottom: '2vh',
  },
  rightHandedContent: {
    paddingBottom: '1vh',
    justifyContent: 'center',
    alignContent: 'center',
  },
  textAlignCenter: {
    textAlign: 'center',
    height: 'fit-content',
    width: '100%',
  },
  alignCenterImage: {
    textAlign: 'center',
    height: 'fit-content',
    width: '100%',
    paddingTop: '2vh',
  },
  total: {
    fontSize: vh(3.125),
    fontWeight: 500,
    letterSpacing: '0.02rem',
    paddingTop: '0.5vh',
  },
  totalLabel: {
    fontSize: vh(1.8),
    color: `${theme.palette.info.dark}`,
    fontWeight: 500,
    paddingTop: '1vh',
  },
  viewContainer: {
    width: '0',
    marginLeft: '1.5vh',
    backgroundColor: themeColor.lightBackground,
  },
  viewHeader: {
    marginLeft: '2%',
    marginRight: '2%',
    marginTop: '2%',
  },
  cancelButton: {
    lineHeight: '1.14',
    letterSpacing: '0.05rem',
    border: `1px solid ${themeColor.almostblack}`,
    fontWeight: 500,
    fontSize: vh(2.08),
    height: '7.29vh',
    width: '14.6vh',
    borderRadius: '2px',
    boxShadow: `0 1px 3px 0 ${themeColor.almostwhite}`,
    '& > div': {
      color: themeColor.almostblack,
    },
  },
  rejectButton: {
    backgroundColor: themeColor.white,
    lineHeight: '1.14',
    letterSpacing: '0.05rem',
    fontWeight: 500,
    fontSize: vh(2.08),
    height: '7.29vh',
    borderRadius: '2px',
    marginRight: '5px',
    boxShadow: `0 1px 3px 0 ${themeColor.almostwhite}`,
    '& > div': {
      color: themeColor.almostblack,
    },
  },
}));
